import React, { useMemo } from 'react';
import { Business, Security } from "@mui/icons-material";
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import CardAdministrador from "../../../../components/ui/materialui/cardAdministrador";
import { Grid2 } from "@mui/material";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PercentIcon from '@mui/icons-material/Percent';
import TableChartIcon from '@mui/icons-material/TableChart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PolicyIcon from '@mui/icons-material/Policy';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';

interface SecureLink {
    to: string;
    icon: JSX.Element;
    text: string;
    permissions: TipoFuncionalidad[];
}

const Maestros: React.FC = () => {
    const { hasPermission } = usePermissions();

    const linksPermitidos = useMemo(() => {
        const todosLosLinks: SecureLink[] = [
            { 
                to: "/maestros/inmobiliarias", 
                icon: <Business sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Inmobiliarias",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/companias-seguro", 
                icon: <Security sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Compañías seguros",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/responsables", 
                icon: <AssignmentIndIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Responsables",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/tasa", 
                icon: <PercentIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Tasas",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/tabla-desarrollo", 
                icon: <TableChartIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Tablas de desarrollo",
                permissions: [TipoFuncionalidad.Maestros_ver_td, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/correccion-monetaria", 
                icon: <AttachMoneyIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Corrección monetaria",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/poliza-seguro", 
                icon: <PolicyIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Pólizas de seguros",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            },
            { 
                to: "/maestros/institucion-financiera", 
                icon: <Business sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Instituciones financieras",
                permissions: [TipoFuncionalidad.Maestros_ver, TipoFuncionalidad.Maestros_editar] 
            }
        ];

        return todosLosLinks.filter(link => 
            link.permissions.some(perm => hasPermission(perm))
        );
    }, [hasPermission]);

    if (linksPermitidos.length === 0) return null;

    return (
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                <CardAdministrador
                    title="Maestros"
                    icon={<BrightnessHighIcon sx={{ fontSize: 20, color: "white" }} />}
                    links={linksPermitidos}
                    backgroundColor="#17c2e6"
                    linkTextColor="text-info"
                />
            </Grid2>
        </Grid2 >
    );
}

export default Maestros;